import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Alert } from "antd"; // Alert ekledim bilgi için
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";

const { Option } = Select;

// Layout ayarları aynen kalıyor...
const formItemLayout = {
  labelCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 12 } },
};

const MaterialCategoryAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // STATE'LER (Sadece 2 Seviye Parent Yeterli)
  const [level1Categories, setLevel1Categories] = useState([]); // Ana Kategoriler
  const [level2Categories, setLevel2Categories] = useState([]); // Alt Kategoriler

  const [selectedLevel1Id, setSelectedLevel1Id] = useState(null);
  
  // UX İÇİN: Kullanıcıya ne eklediğini gösterelim
  const [currentLevelText, setCurrentLevelText] = useState("Kategori (Seviye 1)");

  // Kategori Çekme Fonksiyonu
  const getCategories = (parentId, level) => {
    let filter = "";
    if (level === 1) {
      filter = "ParentId eq null";
    } else {
      if (!parentId) return;
      filter = `ParentId eq ${parentId}`;
    }

    RequestHandler.get(`/MaterialCategory?$filter=${filter}`).then((response) => {
      if (response) {
        if (level === 1) setLevel1Categories(response.value);
        if (level === 2) setLevel2Categories(response.value);
      }
    });
  };

  useEffect(() => {
    // Sayfa açılınca sadece En Tepedeki Ana Kategorileri doldur
    getCategories(null, 1);
  }, []);

  // 1. Kutu Değişince
  const handleLevel1Change = (value) => {
    setSelectedLevel1Id(value);
    setLevel2Categories([]); // Alt kutuyu boşalt
    form.setFieldsValue({ level2Id: null }); // Formdaki değerini sil

    if (value) {
      // Bir Ana Kategori seçildi, altlarını getir.
      getCategories(value, 2);
      setCurrentLevelText("Ana Kategori (Seviye 2)");
    } else {
      // Seçim kaldırıldıysa tekrar en başa dön
      setCurrentLevelText("Kategori (Seviye 1)");
    }
  };

  // 2. Kutu Değişince
  const handleLevel2Change = (value) => {
    if (value) {
      // Alt kategori de seçildi, demek ki en alta detay ekliyor.
      setCurrentLevelText("Detay Kategori (Seviye 3)");
    } else {
      // Alt kategori seçimi kaldırıldı ama üstü seçili
      setCurrentLevelText("Alt Kategori (Seviye 2)");
    }
  };

  const onSuccess = () => {
    form.resetFields();
    setSelectedLevel1Id(null);
    setLevel2Categories([]);
    setCurrentLevelText("Ana Kategori (Seviye 1)");
    getCategories(null, 1); 
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    // MANTIK: 
    // Eğer Level 2 seçiliyse -> Parent = Level 2 (Yeni kayıt Level 3 olur)
    // Eğer Level 1 seçiliyse -> Parent = Level 1 (Yeni kayıt Level 2 olur)
    // Hiçbiri seçili değilse -> Parent = NULL    (Yeni kayıt Level 1 olur)

    let parentIdToSend = null;

    if (values.level2Id) {
      parentIdToSend = values.level2Id;
    } else if (values.level1Id) {
      parentIdToSend = values.level1Id;
    }

    const finalValues = {
      name: values.name,
      code: values.code,
      ParentId: parentIdToSend, // Backend'e giden tek ve net ID
    };

    setLoading(true);
    RequestHandler.post(`/MaterialCategory`, finalValues).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="MaterialAdd"
      onFinish={onFinish}
    >
      <Row>
        <Col span={24}>
          
          {/* Bilgi Mesajı: Kullanıcı o an ne eklediğini bilsin */}
          <Row justify="center" style={{ marginBottom: 20 }}>
             <Col span={16}>
                <Alert message={`Şu an ekleyeceğiniz tür: ${currentLevelText}`} type="info" showIcon />
             </Col>
          </Row>

          {/* 1. SEVİYE SEÇİMİ (Ana Kategoriler) */}
          <Form.Item label="Ana Kategori" name="level1Id">
            <Select
              placeholder="Yok (Ana Kategori Olarak Ekle)"
              allowClear
              onChange={handleLevel1Change}
            >
              {level1Categories.map((cat) => (
                <Option key={cat.id} value={cat.id}>{cat.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {/* 2. SEVİYE SEÇİMİ (Alt Kategoriler) */}
          {/* Sadece üstü seçiliyse görünür */}
          {selectedLevel1Id && (
            <Form.Item label="Alt Kategori" name="level2Id">
              <Select
                placeholder="Yok (Alt Kategori Olarak Ekle)"
                allowClear
                onChange={handleLevel2Change}
                disabled={level2Categories.length === 0}
              >
                {level2Categories.map((cat) => (
                  <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {/* İSİM GİRİŞİ */}
          <Form.Item
            label="Kategori Adı"
            name="name"
            rules={[{ required: true, message: "Lütfen isim giriniz." }]}
          >
            <Input placeholder="Örn: Taksi Fişi" />
          </Form.Item>

          <Form.Item label="Kategori Kodu" name="code">
            <Input />
          </Form.Item>

          <Row justify="end">
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default MaterialCategoryAddForm;